import { TransformInt } from '../../../decorators/transform-int.decorator';

/**
 * Base update DTO
 */
export abstract class BaseUpdateDto {
	@TransformInt()
	id!: number;
}
